import React from "react";

export default function MapFooter() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Map Section - Full Screen */}
      <div className="h-screen w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2695.123456789!2d22.123456!3d48.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDA3JzI0LjQiTiAyMsKwMDcnMjQuNCJF!5e0!3m2!1shu!2shu!4v1234567890123!5m2!1shu!2shu"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="XL bútor Location Map"
        ></iframe>
      </div>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            {/* Címünk */}
            <div>
              <h3 className="font-bold text-lg mb-4 text-red-500">Címünk</h3>
              <p className="text-sm">Kisvárda, Attila u. 61, 4600</p>
            </div>

            {/* Nyitvatartás */}
            <div>
              <h3 className="font-bold text-lg mb-4 text-red-500">Nyitvatartás</h3>
              <p className="text-sm">Hétfő - Péntek: 9:00-17:00</p>
              <p className="text-sm">Szombat: 8:00-13:00</p>
            </div>

            {/* Kapcsolat */}
            <div>
              <h3 className="font-bold text-lg mb-4 text-red-500">Kapcsolat</h3>
              <div className="space-y-2 text-sm">
                <p>📞 Telefonszám: 06 (70) 417 9210</p>
                <p>✉️ xlbutorbolt@gmail.com</p>
              </div>
            </div>

          </div>
        </div>
      </footer>
    </div>
  );
}

